import React, { Component } from 'react';
import { connect } from 'react-redux';
import Swiper from 'react-id-swiper';
import BgImage from './../dom-elements/BgImage';
import { heights, colors, breakpoints } from './../../styles/theme.json';
import { arrayPosition } from './../../scripts';

class PopoverSwiper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      revealSlider: false,
      startPosition: arrayPosition(this.props.PortfolioImages, this.props.currentImage),
      currentSlide: arrayPosition(this.props.PortfolioImages, this.props.currentImage),
      navOpen: false,
      portfolioImageCount: 0
    };
    this.keydown = this._handleKeyDown.bind(this);
  }

  _slideNav(id) {
    this.swiper.slideTo(id);
  }

  _slideChange() {
    this.setState({ currentSlide: this.swiper.realIndex });
  }

  _mouseOut() {
    this.setState({
      navOpen: false
    });
  };

  _mouseOver() {
    this.setState({
      navOpen: true
    });
  };

  _handleKeyDown(event) {
    switch ( event.keyCode ) {
      case 38:
        this.setState({
          navOpen: true
        });
        break;
      case 40:
        this.setState({
          navOpen: false
        });
        break;
      default:
        break;
    };
  };

  _getThumbWidth() {
    const thumbCount = this.props.PortfolioImages.length;
    if (thumbCount < 10) {
      const thumbWidth = Math.round((100 / thumbCount) * 100) / 100;
      return {
        thumb_width: {
          width: `${thumbWidth}vw`
        },
        overflow: {
          overflow: 'hidden'
        }
      };
    } else {
      return {
        thumb_width: {
          width: '10vw'
        },
        overflow: {
          overflowX: 'scroll',
          overflowY: 'hidden'
        }
      };
    }
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        revealSlider: true
      });
      this.swiper.slideTo(this.state.startPosition);
    }, 250);
  };

  componentWillMount(){
    document.addEventListener('keydown', this.keydown);
  };

  componentWillUnmount() {
    document.removeEventListener('keydown', this.keydown);
  };

  render() {
    const ImgBar = this.props.PortfolioImages.map((item, i) =>
      <li className={(this.state.currentSlide == i) ? 'image-bar-item active' : 'image-bar-item'} style={this._getThumbWidth().thumb_width} key={'img-bar-thumb-' + item.urls.id + i}>
        <button className={'slider-nav'} onClick={() => this._slideNav(i)}>
          <img className='slider-nav-image' src={item.urls.large}/>
        </button>
        <style jsx>{`
          .image-bar-item {
            height: ${heights.slider_thumb_height};
            flex-shrink: 0;
            flex-grow: 0;
            position: relative;
            overflow: hidden;
          }
          .image-bar-item.active > .slider-nav {
            opacity: 1!important;
          }
          .slider-nav {
            transition: opacity 250ms ease;
            border: 0;
            cursor: pointer;
            background-color: ${colors.black};
            opacity: 0.25;
            height: 100%;
            width: 100%;
            position: absolute;
            overflow: hidden;
            border-right: 2px solid black;
          }
          .slider-nav-image {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            object-fit: cover;
            margin: auto;
          }
          .slider-nav:hover {
            opacity: 1;
          }
          .thumb-wrapper {
            width: 100%;
          }
        `}</style>
      </li>
    );

    const GalleryItems = this.props.PortfolioImages.map((item, i) =>
      <div className={'slider-image'} key={'slider-img-' + item.urls.id + i}>
        <div className={'image-wrapper'}>
          <BgImage source={item.urls.large} bgSize={'contain'} />
        </div>
        <style jsx>{`
          .slider-image {
            height: 100vh;
          }
          .image-wrapper {
            width: 100vw;
            height: 100%;
            padding-top: 0;
            padding-left: 0;
            padding-right: 0;
            padding-bottom: 0;
            display: flex;
          }
          .caption-wrap {
            padding-top: 2rem;
            width: 100%;
            display: flex;
            justify-content: center;
            text-align: left;
          }
          @media (min-width: 640px) {
            .image-wrapper {
              padding-top: 0;
              padding-left: ${heights.slider_thumb_height};
              padding-right: ${heights.slider_thumb_height};
              padding-bottom: 0;
            }
            .caption-wrap {
              padding-top: 2rem;
              margin: auto;
            }
          }
        `}</style>
      </div>
    );

    const swiperParams = {
      on: {
        slideChange: () => {
          this._slideChange();
        }
      },
      navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev'
      },
      spaceBetween: 30,
      pagination: {
        type: 'bullets',
        dynamicBullets: false,
        clickable: true
      },
      keyboard: true
    };

    return (
      <div id='portfolio-popover'>
        {(this.state.revealSlider) &&
          <div id='popover-slider' className={(this.state.navOpen) ? 'nav-open pop-in' : 'pop-in'}>
            <Swiper {...swiperParams} ref={node => { if (node) this.swiper = node.swiper; }}>
              {GalleryItems}
            </Swiper>
          </div>
        }
        {(this.props.window_width >= breakpoints.desktop) &&
          <div id={'slider-nav'}
            onMouseOut={() => this._mouseOut()}
            onMouseOver={() => this._mouseOver()}
            style={this._getThumbWidth().overflow}
            className={(this.state.navOpen) ? 'slider-nav-active' : ''}
          >
            <ul id={'image-bar'}>
              {ImgBar}
            </ul>
          </div>
        }
        <style jsx>{`
          #popover-slider {
            height: 100vh;
            width: 100vw;
            position: absolute;
            top: 0;
            left: 0;
            transform: translateY(0);
            transition: transform 350ms ease;
            will-change: transition;
          }
          .nav-open {
            transform: translateY(-5rem)!important;
          }
          :global(.swiper-next),
          :global(.swiper-prev) {
            display: none;
            position: absolute;
            height: 3rem;
            width: 3.5rem;
            cursor: pointer;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
            color: transparent;
            background-color: transparent;
            top: 50%;
            border: none;
            outline: none;
            z-index: 12000;
            opacity: .85;
            text-transform: uppercase;
          }
          :global(.swiper-prev) {
            left: 1.5rem;
            background-image: url('/static/icons/arrow-left-white.svg');
          }
          :global(.swiper-next) {
            right: 1.5rem;
            background-image: url('/static/icons/arrow-right-white.svg');
          }
          @media (min-width: 640px) {
            :global(.swiper-next),
            :global(.swiper-prev) {
              display: block;
            }
          }
          #portfolio-popover {
            width: 100%;
            height: 100%;
            display: flex;
            position: absolute;
            z-index: 10000;
            top: 0;
            left: 0;
          }
          #slider-nav {
            height: ${heights.slider_thumb_height};
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100vw;
            cursor: pointer;
            border-right: 2px solid black;
            border-left: 2px solid black;
          }
          .slider-nav-active > #image-bar {
            transform: translateY(0);
          }
          #image-bar {
            background-color: black;
            transition: transform 350ms ease;
            will-change: transition;
            transform: translateY(calc(${heights.slider_thumb_height} - ${heights.thumb_hl_height}));
            list-style: none;
            display: block;
            height: ${heights.slider_thumb_height};
            z-index: 2;
            padding: 0;
            display: flex;
            flex-direction: row;
            position: relative;
            cursor: pointer;
          }
        `}</style>
      </div>
    );
  };
};

export default connect(
  state => ({
    window_width: state.window_dimensions.window_width
  })
)(PopoverSwiper);



// WEBPACK FOOTER //
// ./src/components/popover/PopoverSwiper.js